import moment from 'moment'

import texts from '../contributor.texts'

class Step2Controller {
    constructor($scope, $state, $stateParams, config, SharedMoments, Share) {
        this.name = 'step2'

        this.$scope = $scope
        this.$state = $state
        this.$stateParams = $stateParams

        this.config = config
        this.SharedMoments = SharedMoments
        this.ShareFactory = Share

        this.posts = []
    }

    $onInit () {
        this.render()

        // Load certificate
        this.getCertificate(this.$stateParams.username)

        // watch thumbs
        this.watchThumbs()

        this.watchLanguage()
    }

    render () {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        if (this.language === 'GE') {
            moment.updateLocale('en', {
                months: [
                    'იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი',
                    'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი'
                ]
            })
        } else {
            moment.updateLocale('en', {
                months: [
                    'January', 'February', 'March', 'April', 'May', 'June', 'July',
                    'August', 'September', 'October', 'November', 'December'
                ]
            })
        }

        const {
            SHARE,
            SELECTED_POSTS,
            APPRECIATIONS,
            CLOSE
        } = texts[this.language]

        this.share = SHARE
        this.appreciationsText = APPRECIATIONS
        this.selectedPostsText = SELECTED_POSTS
        this.closeText = CLOSE
    }

    getCertificate (username) {
        this.SharedMoments.getCertificate(username)
            .then((response) => {
                if (!response.data || !response.data.posts) {
                    return this.$state.go('home.contributor.step1')
                }

                const {
                    fullName,
                    avatarUrl,
                    createdAt,
                    posts
                } = response.data

                this.username = username
                this.fullName = fullName
                this.avatarUrl = avatarUrl
                this.createdAt = moment(createdAt).format('DD MMMM, YYYY')
                this.posts = posts
                this.selectedPosts = posts.length

                this.avatarStyle = {
                    'background-image': `url("${this.avatarUrl || '/assets/images/user.jpg'}")`
                }
            })
            .catch((err) => {
                console.log('Error occured in method checkContributor', err)

                this.error = err.data
            })
    }

    shareCertificate () {
        const url = `${this.config.frontUrl}/shared-moments/contributor/step-2?username=${this.username}`

        this.ShareFactory
            .shareObject(url)
    }

    watchThumbs () {
        this.$scope.$watch(() => this.posts.reduce((thumbs, item) => thumbs + item.thumbs, 0), (newValue) => {
            this.appreciations = newValue
        })
    }

    watchLanguage () {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }
}

Step2Controller.$inject = ['$scope', '$state', '$stateParams', 'config', 'SharedMoments', 'Share']

export default Step2Controller



// WEBPACK FOOTER //
// ./client/app/components/home/contributor/step2/step2.controller.js